<template>
  <FeedFilterTag v-if="type === CATEGORY_TYPE.NEWS" :on-click="handleClick">
    {{ parameter?.name || '' }}: {{ value?.value || '' }}
  </FeedFilterTag>
</template>

<script setup>
import _ from 'lodash-es';
import { CATEGORY_TYPE } from "@utils/constants";
import { useEnumStore } from '@stores/enum';
import FeedFilterTag from "@components/filter/feed/feed-filter-tag";

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  type: {
    type: String,
    default: 'eshop'
  }
});

const route = useRoute();
const enums = useEnumStore();

const parameter = computed(() => _.find(enums.contentParameters || [], { id: props.data.idParameter }));
const value = computed(() => _.find(parameter.value?.values || [], { id: props.data.idValue }));

const handleClick = async () => {
  const params = { ...route.query };
  const queryKey = `t[${props.data.idParameter}]`;
  await useSearchParam(queryKey, _.chain(params[queryKey] || '').split(',').filter(idValue => parseInt(idValue) !== props.data.idValue).join(',').value());
}

</script>
